import { genLookupObjAndFun } from "./generic";

export const entityTypes = [
  { name: "healthcare", description: "Healthcare Provider" },
  { name: "hospital", description: "Hospital" },
];

export const [entityTypeByName, getEntityTypeByName] =
  genLookupObjAndFun(entityTypes);
